import { RefObject } from 'react';

import { ItemType, MappingItemIdIndexType } from '../../types';

export function setRowClas(rowsMap: Map<string, RefObject<HTMLDivElement>[]>, itemId: string, className: string) {
    const row = rowsMap.get(itemId);
    if (row) {
        for (const cell of row) {
            if (cell.current) {
                cell.current.classList.add(className);
            }
        }
    }
}

export function removeRowClass(rowsMap: Map<string, RefObject<HTMLDivElement>[]>, itemId: string, className: string) {
    const row = rowsMap.get(itemId);
    if (row) {
        for (const cell of row) {
            if (cell.current) {
                cell.current.classList.remove(className);
            }
        }
    }
}

export function setRowBorder(
    itemId: string,
    rowsMap: Map<string, RefObject<HTMLDivElement>[]>,
    borderLeftClass: string,
    borderRightClass: string,
    borderTopBottomClass: string,
) {
    const row = rowsMap.get(itemId);
    if (row) {
        for (const cell of row) {
            if (cell.current) {
                cell.current.classList.add(borderTopBottomClass);
            }
        }
        const [firstCell] = row;

        if (firstCell.current) {
            firstCell.current.classList.add(borderLeftClass);
        }

        const lastCell = row[row.length - 1];

        if (lastCell.current) {
            lastCell.current.classList.add(borderRightClass);
        }
    }
}

export function removeRowBorder(
    itemId: string,
    rowsMap: Map<string, RefObject<HTMLDivElement>[]>,
    borderLeftClass: string,
    borderRightClass: string,
    borderTopBottomClass: string,
) {
    const row = rowsMap.get(itemId);
    if (row) {
        for (const cell of row) {
            if (cell.current) {
                cell.current.classList.remove(borderTopBottomClass);
            }
        }
        const [firstCell] = row;

        if (firstCell.current) {
            firstCell.current.classList.remove(borderLeftClass);
        }

        const lastCell = row[row.length - 1];

        if (lastCell.current) {
            lastCell.current.classList.remove(borderRightClass);
        }
    }
}

const getItem = (id: string, items: ItemType[], mappingItemIdIndex: MappingItemIdIndexType) => {
    return items[mappingItemIdIndex[id]];
};

export function findLastExpandedChild(
    itemId: string,
    items: ItemType[],
    mappingItemIdIndex: MappingItemIdIndexType,
): string {
    const item = getItem(itemId, items, mappingItemIdIndex);

    if (!item || item.hideForCollapse || !item.children || item.children.length === 0) {
        return itemId;
    }

    const lastChildId = item.children[item.children.length - 1];

    const lastChildItem = getItem(lastChildId, items, mappingItemIdIndex);
    const isItemCollapsed = lastChildItem?.hideForCollapse;

    if (isItemCollapsed) {
        return itemId;
    }

    return findLastExpandedChild(lastChildId, items, mappingItemIdIndex);
}
